// Rule offsets are stored in minutes but may be any whole number of seconds
// (0.5 = 30 s, 0.0167 ≈ 1 s) — round to seconds for display and editing.
export function offsetToSeconds(minutes) {
  return Math.max(0, Math.round(Number(minutes || 0) * 60));
}

// 0 → "0s", 30 → "30s", 75 → "1m 15s", 900 → "15m"
export function formatOffset(minutes) {
  const total = offsetToSeconds(minutes);
  const m = Math.floor(total / 60), s = total % 60;
  if (m === 0) return `${s}s`;
  return s === 0 ? `${m}m` : `${m}m ${s}s`;
}
